import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AccountService} from '../../services/account.service';
import {OdmLoginComponent} from '../../ODM/odm-login/odm-login.component';
import {SignUpComponent} from '../../ODM/sign-up/sign-up.component';
import {ForgetPasswordComponent} from '../../ODM/forget-password/forget-password.component';
import {ActivateAccountComponent} from '../../ODM/activate-account/activate-account.component';
import {ResetPasswordComponent} from '../../ODM/reset-password/reset-password.component';
import {ShareModule} from '../share/share.module';
import {HttpClientModule} from '@angular/common/http';

@NgModule({
  declarations: [
    OdmLoginComponent,
    SignUpComponent,
    ForgetPasswordComponent,
    ActivateAccountComponent,
    ResetPasswordComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    ShareModule,
  ],
  providers: [AccountService]
})
export class AccountModule { }
